import styled from 'styled-components';
import { Box, Grid, makeStyles } from '@material-ui/core';
import { SmallSectionHeader, ShortBody } from 'components/Typography';
import breakpoints from 'utils/breakpoints';

export const FaqContainer = styled(Box)`
  box-sizing: border-box;
  height: 100%;
`;

export const FaqWrapper = styled(Grid)`
  height: 100%;
  box-sizing: border-box;
  @media (max-width: ${breakpoints.xs}) {
    span {
      font-size: 11px;
    }
    h4 {
      font-size: 15px;
    }
  }
`;

export const StyledSmallSectionHeader = styled(SmallSectionHeader)`
  margin-bottom: 0px !important;
`;

export const useButtonStyles = makeStyles({
  root: {
    marginBottom: '0px',
    fontSize: '12px !important',
    fontWeight: 400,
    textAlign: 'end',
    lineHeight: '14px',
  },
});

interface ShortBodyType {
  lineHeight?: string;
  weight?: string;
  color?: string;
}
export const StyledShortBody = styled(ShortBody)<ShortBodyType>`
  line-height: 18px !important;
  font-size: 13px !important;
  margin-bottom: 0px !important;
`;
